<template>
  <div class="wrapper">
    <div class="widget-container">
      <svg class="rotating-arcs" viewBox="0 0 200 200">
        <path
          d="M 100,45 A 55,55 0 0,1 155,100"
          fill="none"
          :stroke="`${riskColor}4D`"
          stroke-width="4"
        />
      </svg>
      <svg
        class="rotating-arcs"
        style="animation-delay: -4s"
        viewBox="0 0 200 200"
      >
        <path
          d="M 100,45 A 55,55 0 0,1 155,100"
          fill="none"
          :stroke="`${riskColor}4D`"
          stroke-width="4"
        />
      </svg>
      <div class="central-circle" :style="{ background: riskColor }">
        <span class="risk-label">ВАШ РИСК</span>
        <span class="risk-value">{{ riskLevel }}</span>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { ref, onMounted, watch, onUnmounted } from "vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "RiskWidget",
  setup() {
    const riskLevel = ref("СРЕДНИЙ");
    const riskColor = ref("#f59e21"); // Оранжевый по умолчанию

    // Функция для загрузки данных о риске из localStorage
    const loadRiskData = () => {
      console.log("Загрузка данных о риске из localStorage...");
      const savedRiskData = localStorage.getItem("health_risk_data");

      if (savedRiskData) {
        try {
          const parsedData = JSON.parse(savedRiskData);
          console.log("Данные о риске получены:", parsedData);

          // Устанавливаем уровень риска из сохраненных данных
          if (parsedData.totalRiskLevel) {
            const newRiskLevel = parsedData.totalRiskLevel;
            console.log(
              `Обновление уровня риска: ${riskLevel.value} -> ${newRiskLevel}`
            );
            riskLevel.value = newRiskLevel;

            // Устанавливаем цвет в зависимости от уровня риска
            let newColor = "#f59e21"; // Оранжевый по умолчанию
            if (riskLevel.value === "НИЗКИЙ") {
              newColor = "#4baf50"; // Зеленый
            } else if (riskLevel.value === "СРЕДНИЙ") {
              newColor = "#f59e21"; // Оранжевый
            } else if (riskLevel.value === "ВЫСОКИЙ") {
              newColor = "#fc4a25"; // Красный
            }

            console.log(`Обновление цвета: ${riskColor.value} -> ${newColor}`);
            riskColor.value = newColor;
          } else {
            console.log("Уровень риска не найден в данных");
          }

          console.log("Данные о риске загружены в виджет:", riskLevel.value);
        } catch (error) {
          console.error("Ошибка при загрузке данных о риске:", error);
        }
      } else {
        console.log("Данные о риске не найдены в localStorage");
        // Устанавливаем значения по умолчанию
        riskLevel.value = "СРЕДНИЙ";
        riskColor.value = "#f59e21"; // Оранжевый
      }
    };

    // Слушаем изменения в localStorage через событие storage
    window.addEventListener("storage", (event) => {
      if (event.key === "health_risk_data") {
        loadRiskData();
      }
    });

    // Создаем обработчик пользовательского события для обновления данных
    const handleRiskUpdate = () => {
      loadRiskData();
    };

    // Добавляем слушатель пользовательского события
    window.addEventListener("risk-data-updated", handleRiskUpdate);

    onMounted(() => {
      loadRiskData();
    });

    // Удаляем слушатели событий при уничтожении компонента
    onUnmounted(() => {
      window.removeEventListener("storage", (event) => {
        if (event.key === "health_risk_data") {
          loadRiskData();
        }
      });
      window.removeEventListener("risk-data-updated", handleRiskUpdate);
    });

    return {
      riskLevel,
      riskColor,
    };
  },
});
</script>
<style scoped>
.widget-container {
  position: relative;
  width: 300px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.central-circle {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: Arial, sans-serif;
  font-weight: bold;
  z-index: 2;
  color: #fff;
  position: absolute;
  flex-direction: column;
  box-shadow: 0px 2px 4px 2px #e0e0e0;
  transition: background-color 0.3s ease;
}

.risk-label {
  font-size: 10pt;
  margin-bottom: 5px;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
}

.risk-value {
  font-size: 14pt;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.rotating-arcs {
  position: absolute;
  width: 100%;
  height: 100%;
  animation: rotate 8s linear infinite;
}

.arc-container {
  position: absolute;
  width: 100%;
  height: 100%;
}

.arc-container:nth-child(2) {
  transform: rotate(180deg);
}
.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: -40px;
  margin-top: -60px;
}
</style>
